import { clsx } from 'clsx';
import React from 'react';

import { IBooking } from '@/services/types/booking/details';

import BookingCard from './BookingCard';

type TBookingCardContainerProps = {
  bookings: IBooking[];
  isNewHomepage?: boolean;
  isAuto?: boolean;
};

const BookingCardContainer = ({
  bookings,
  isNewHomepage = false,
  isAuto = false,
}: TBookingCardContainerProps) => {
  if (!bookings?.length) return null;

  return (
    <div
      className={clsx('mx-4 mb-8 md:mx-0', {
        'mb-0 bg-white !mx-0 rounded-2xl': isNewHomepage,
      })}>
      <div
        className={clsx('grid grid-cols-1 gap-x-12 gap-y-2 sm:gap-y-8', {
          'md:gap-x-0': isNewHomepage,
          'xl:grid-cols-2': !isNewHomepage,
        })}>
        {bookings.map(trip => (
          <BookingCard key={trip.id} booking={trip} isNewHomepage={isNewHomepage} isAuto={isAuto} />
        ))}
      </div>
    </div>
  );
};

export default BookingCardContainer;
